import axios from '@/http';

export default {
  async logout({ commit }) {
    try {
      const res = await axios.get('/admin/logout');
      commit('USER_LOGOUT');
      window.location = res.data.redirect_url;
    } catch (e) {
      console.error(e);
    }
  },
};
